import i18n from "utilities/i18n";
import { OptionType } from "elements";

export class DeviceSettingOptions {
  static muteOffAlertOpts: OptionType[] = [
    { value: "false", text: i18n.t("TONE") },
    { value: "true", text: i18n.t("VOICE") }
  ];

  static acousticFenceOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "60", text: i18n.t("NARROW") },
    { value: "90", text: i18n.t("MEDIUM") },
    { value: "120", text: i18n.t("WIDE") }
  ];

  static defaultPhoneLineOpts: OptionType[] = [
    { value: "pstn", text: i18n.t("DESK_PHONE") },
    { value: "voip", text: i18n.t("COMPUTER") },
    { value: "mobile", text: i18n.t("MOBILE") }
  ];

  static muteReminderTimingOpts: OptionType[] = [
    { value: "1", text: i18n.t("MINUTE_NO_PERIOD", { count: 1 }) },
    { value: "2", text: i18n.t("MINUTE_NO_PERIOD", { count: 2 }) },
    { value: "3", text: i18n.t("MINUTE_NO_PERIOD", { count: 3 }) },
    { value: "4", text: i18n.t("MINUTE_NO_PERIOD", { count: 4 }) },
    { value: "5", text: i18n.t("MINUTE_NO_PERIOD", { count: 5 }) },
    { value: "6", text: i18n.t("MINUTE_NO_PERIOD", { count: 6 }) },
    { value: "7", text: i18n.t("MINUTE_NO_PERIOD", { count: 7 }) },
    { value: "8", text: i18n.t("MINUTE_NO_PERIOD", { count: 8 }) },
    { value: "9", text: i18n.t("MINUTE_NO_PERIOD", { count: 9 }) },
    { value: "10", text: i18n.t("MINUTE_NO_PERIOD", { count: 10 }) },
    { value: "11", text: i18n.t("MINUTE_NO_PERIOD", { count: 11 }) },
    { value: "12", text: i18n.t("MINUTE_NO_PERIOD", { count: 12 }) },
    { value: "13", text: i18n.t("MINUTE_NO_PERIOD", { count: 13 }) },
    { value: "14", text: i18n.t("MINUTE_NO_PERIOD", { count: 14 }) },
    { value: "15", text: i18n.t("MINUTE_NO_PERIOD", { count: 15 }) }
  ];

  static muteAlertTypeOpts: OptionType[] = [
    { value: "voice", text: i18n.t("VOICE") },
    { value: "singleTone", text: i18n.t("SINGLE_TONE") },
    { value: "doubleTone", text: i18n.t("DOUBLE_TONE") }
  ];

  static muteReminderModeOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "timed", text: i18n.t("TIME_BASED") },
    { value: "voiceAudible", text: i18n.t("VOICE_DETECTED_AUDIO") },
    { value: "voiceVisible", text: i18n.t("VISUAL") },
    { value: "voiceVisibleAndAudible", text: i18n.t("AUDIO_VISUAL") }
  ];

  static connectionIndicationOpts: OptionType[] = [
    { value: "voice", text: i18n.t("VOICE") },
    { value: "tone", text: i18n.t("TONE") }
  ];

  static closeConversationLimitingOpts: OptionType[] = [
    { value: "no", text: i18n.t("NO_LIMITING") },
    { value: "moderate", text: i18n.t("STANDARD") },
    { value: "agressive", text: i18n.t("MAXIMUM") }
  ];

  static ancTimeoutOpts: OptionType[] = [
    { value: "2", text: i18n.t("HOUR", { count: 2 }) },
    { value: "4", text: i18n.t("HOUR", { count: 4 }) },
    { value: "off", text: i18n.t("OFF") }
  ];

  static rocketButtonOpts: OptionType[] = [
    { value: "playPause", text: i18n.t("PLAY_PAUSE") },
    { value: "redial", text: i18n.t("REDIAL_MOBILE") },
    { value: "vpa", text: i18n.t("VIRTUAL_PERSONAL_ASSISTANT") },
    {
      value: "clearTrustedDevice",
      text: i18n.t("CLEAR_TRUSTED_DEVICE_LIST")
    },
    { value: "statusCheck", text: i18n.t("STATUS_CHECK") },
    { value: "holdResume", text: i18n.t("HOLD_RESUME_CALL") }
  ];

  static languageOpts: OptionType[] = [
    { value: "3076", text: "Cantonese" },
    { value: "1030", text: "Danish" },
    { value: "2057", text: "English - United Kingdom" },
    { value: "1033", text: "English - United States" },
    { value: "1036", text: "French" },
    { value: "1031", text: "German" },
    { value: "1040", text: "Italian" },
    { value: "1041", text: "Japanese" },
    { value: "1042", text: "Korean" },
    { value: "1045", text: "Polish" },
    { value: "2052", text: "Mandarin" },
    { value: "1044", text: "Norwegian - Bokml" },
    { value: "2068", text: "Norwegian - Nynorsk" },
    { value: "1049", text: "Russian" },
    { value: "1034", text: "Spanish" },
    { value: "1053", text: "Swedish" },
    { value: "16393", text: "English - India" },
    { value: "1057", text: "Indonesian" },
    { value: "1054", text: "Thai" },
    { value: "1046", text: "Portuguese - Brazil" }
  ];

  static activeCallAudioOpts: OptionType[] = [
    { value: "doNothing", text: i18n.t("DO_NOTHING") },
    {
      value: "transferAudioToMobile",
      text: i18n.t("TRANSFER_AUDIO_TO_MOBILE_PHONE")
    },
    { value: "muteMic", text: i18n.t("MUTE_MICROPHONE") }
  ];

  static audioQualityOpts: OptionType[] = [
    { value: "homeMode", text: i18n.t("MUSIC") },
    { value: "enterpriseMode", text: i18n.t("HYBRID") },
    { value: "mono", text: i18n.t("CONVERSATION") }
  ];

  static computerAudioBandwidthOpts: OptionType[] = [
    { value: "narrowband", text: i18n.t("NARROWBAND") },
    { value: "wideband", text: i18n.t("WIDEBAND") }
  ];

  static deskPhoneAudioBandwidthOpts: OptionType[] = [
    { value: "narrowband", text: i18n.t("NARROWBAND") },
    { value: "wideband", text: i18n.t("WIDEBAND") }
  ];

  static hdVoiceOpts: OptionType[] = [
    { value: "narrowband", text: i18n.t("OFF") },
    { value: "wideband", text: i18n.t("ON") },
    { value: "stereo", text: i18n.t("STEREO") },
    { value: "widebandStereo", text: i18n.t("WIDEBAND_STEREO") }
  ];

  static bluetoothStreamingOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "on", text: i18n.t("ON") }
  ];

  static secondIncomingCallOpts: OptionType[] = [
    { value: "ignore", text: i18n.t("IGNORE") },
    { value: "once", text: i18n.t("RING_ONCE") },
    { value: "continuous", text: i18n.t("RING_CONTINUOUSLY") }
  ];

  static computerVolumeOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "low", text: i18n.t("LOW_VOLUME") },
    { value: "standard", text: i18n.t("STANDARD_VOLUME") }
  ];

  static deskPhoneVolumeOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "low", text: i18n.t("LOW_VOLUME") },
    { value: "standard", text: i18n.t("STANDARD_VOLUME") }
  ];

  static mobilePhoneVolumeOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "low", text: i18n.t("LOW_VOLUME") },
    { value: "standard", text: i18n.t("STANDARD_VOLUME") }
  ];

  static computerRingtoneOpts: OptionType[] = [
    { value: "sound1", text: i18n.t("TONE_ONE") },
    { value: "sound2", text: i18n.t("TONE_TWO") },
    { value: "sound3", text: i18n.t("TONE_THREE") },
    { value: "off", text: i18n.t("OFF") }
  ];

  static deskPhoneRingtoneOpts: OptionType[] = [
    { value: "sound1", text: i18n.t("TONE_ONE") },
    { value: "sound2", text: i18n.t("TONE_TWO") },
    { value: "sound3", text: i18n.t("TONE_THREE") },
    { value: "off", text: i18n.t("OFF") }
  ];

  static mobilePhoneRingtoneOpts: OptionType[] = [
    { value: "sound1", text: i18n.t("TONE_ONE") },
    { value: "sound2", text: i18n.t("TONE_TWO") },
    { value: "sound3", text: i18n.t("TONE_THREE") },
    { value: "off", text: i18n.t("OFF") }
  ];

  static muteReminderVolumeOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "low", text: i18n.t("LOW_VOLUME") },
    { value: "standard", text: i18n.t("STANDARD_VOLUME") }
  ];

  static audioPromptVolumeOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "low", text: i18n.t("LOW_VOLUME") },
    { value: "standard", text: i18n.t("STANDARD_VOLUME") }
  ];

  static volumeLevelIndicatorsOpts: OptionType[] = [
    { value: "atEveryLevel", text: i18n.t("EVERY_LEVEL") },
    { value: "minMaxOnly", text: i18n.t("MIN_MAX_ONLY") }
  ];

  static sidetoneOpts: OptionType[] = [
    { value: "low", text: i18n.t("LOW") },
    { value: "medium", text: i18n.t("MEDIUM") },
    { value: "high", text: i18n.t("HIGH") }
  ];

  static volumeAlertsOpts: OptionType[] = [
    { value: "voice", text: i18n.t("VOICE") },
    { value: "tone", text: i18n.t("TONE") }
  ];

  static noiseExposureLimitOpts: OptionType[] = [
    { value: "85db", text: i18n.t("LIMITED_85DBA") },
    { value: "80db", text: i18n.t("LIMITED_80DBA") },
    { value: "off", text: i18n.t("NO_LIMITING") }
  ];

  static hoursOnPhoneDayOpts: OptionType[] = [
    { value: "off", text: i18n.t("OFF") },
    { value: "2", text: "2" },
    { value: "4", text: "4" },
    { value: "6", text: "6" },
    { value: "8", text: "8" }
  ];

  static increaseQdHeadsetVolumeOpts: OptionType[] = [
    { value: "new", text: i18n.t("ENCORE_PRO_500") },
    { value: "legacy", text: i18n.t("ENCORE_PRO_700") }
  ];

  static wearingPreferenceOpts: OptionType[] = [
    { value: "unknown", text: i18n.t("NO_CHANGE") },
    { value: "left", text: i18n.t("LEFT_EAR") },
    { value: "right", text: i18n.t("RIGHT_EAR") },
    { value: "leftRight", text: i18n.t("BOOM_ON_RIGHT") },
    { value: "leftRightSwapped", text: i18n.t("BOOM_ON_LEFT") }
  ];

  static toneControlOpts: OptionType[] = [
    { value: "maxBass", text: i18n.t("MAX_BASS") },
    { value: "midBass", text: "-2" },
    { value: "minBass", text: "-1" },
    { value: "noBoost", text: "0" },
    { value: "minTreble", text: "1" },
    { value: "midTreble", text: "2" },
    { value: "maxTreble", text: i18n.t("MAX_TREBLE") }
  ];

  static trackingSpeedOpts: OptionType[] = [
    { value: "slow", text: i18n.t("SLOW") },
    { value: "normal", text: i18n.t("NORMAL") },
    { value: "fast", text: i18n.t("FAST") }
  ];

  static trackingModeOpts: OptionType[] = [
    { value: "speaker", text: i18n.t("SPEAKER") },
    { value: "off", text: i18n.t("OFF") },
    { value: "group", text: i18n.t("GROUP") }
  ];

  static antiFlickerOpts: OptionType[] = [
    { value: "0", text: i18n.t("DISABLED") },
    { value: "1", text: i18n.t("FIFTY_HZ") },
    { value: "2", text: i18n.t("SIXTY_HZ") }
  ];

  static frameSizeOpts: OptionType[] = [
    { value: "tight", text: i18n.t("TIGHT") },
    { value: "medium", text: i18n.t("MEDIUM") },
    { value: "wide", text: i18n.t("WIDE") }
  ];

  static maxZoomOpts: OptionType[] = [
    { value: "2x", text: "2x" },
    { value: "3x", text: "3x" },
    { value: "4x", text: "4x" }
  ];

  static cameraMovementOpts: OptionType[] = [
    { value: "auto pan", text: i18n.t("AUTO_PAN") },
    { value: "cut", text: i18n.t("CUT") }
  ];
}
